import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";

import About from "./pages/About";
import Contact from "./pages/Contact";
import Terms from "./pages/Terms";
import Privacy from "./pages/Privacy";
import Refund from "./pages/Refund";

import  Home from "./pages/Home";
import ApiDocs from "./pages/ApiDocs";
import Pricing from "./pages/Pricing";

import BBPS from "./pages/BBPS";
import AEPS from "./pages/AEPS";
import MicroATM from "./pages/Micro-ATM";
import DMT from "./pages/DMT";

import Login from "./pages/Login";
import SignUP from "./pages/SignUP";

function App() {
  return (
    <BrowserRouter>
      <Navbar />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/apidocs" element={<ApiDocs />} />
        <Route path="/pricing" element={<Pricing />} />

        <Route path="/bbps" element={<BBPS />} />
        <Route path="/aeps" element={<AEPS />} />
        <Route path="/micro-atm" element={<MicroATM />} />
        <Route path="/dmt" element={<DMT />} />

        <Route path="/about" element={<About />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="terms" element={<Terms />} />
        <Route path="privacy" element={<Privacy />} />
        <Route path="refund" element={<Refund />} />

        <Route path="login" element={<Login />} />
        <Route path="signup" element={<SignUP />} />

      </Routes>
      <Footer />

    </BrowserRouter>
  );
}

export default App;
